import React from 'react';

// interface
import { IOnboardingItemModuleProps, ILinkProps } from '../../../interfaces/interfaces';

// source
import { ModalContextConsumer } from '../../../contexts/modalContext';
import ModalHelpers from '../../../helpers/ModalHelpers/ModalHelpers';
import keyboardTriggerBasic from '../../../utils/keyboard-trigger';
import Link from '../Link/Link';

function OnboardingItemModule(props: IOnboardingItemModuleProps & ILinkProps): JSX.Element {
  const {
    id,
    headline,
    textContent,
    iconUrl,
    linkHref,
    linkText,
    linkClass,
    linkTarget,
    linkTextClass,
    linkIconClass,
    dataAttributes,
    closeOverlay,
  } = props;

  return (
    <div className="onboarding-item">
      <div className="section">
        <div className="icon">
          <img src={iconUrl} alt="NO ICON" />
        </div>
      </div>

      <div className="onboarding-item-body">
        <h5 className="hl-5">{headline}</h5>
        <p className="tx_2">{textContent}</p>
      </div>

      {/* Because of (onClick) Button devide Link Component ---------------- */}
      {id === '1' && (
        <Link
          // linkHref={linkHref}
          linkText={linkText}
          linkClass={linkClass}
          // linkTarget={linkTarget}
          linkTextClass={linkTextClass}
          linkIconClass={linkIconClass}
          dataAttributes={dataAttributes}
          tabIndex={0}
        />
      )}

      {id === '2' && (
        <ModalContextConsumer>
          {({ openModal }) => (
            <Link
              linkHref={linkHref}
              linkText={linkText}
              linkClass={linkClass}
              linkTarget={linkTarget}
              linkTextClass={linkTextClass}
              linkIconClass={linkIconClass}
              onClick={() => {
                if (closeOverlay) {
                  closeOverlay();
                }
                ModalHelpers.openPersonalisation(openModal);
              }}
            />
          )}
        </ModalContextConsumer>
      )}

      {id === '3' && (
        <Link
          linkHref={linkHref}
          linkText={linkText}
          linkClass={linkClass}
          linkTarget={linkTarget}
          linkTextClass={linkTextClass}
          linkIconClass={linkIconClass}
          onClick={closeOverlay}
          onKeyDown={(e: React.KeyboardEvent<Element>) => {
            if (closeOverlay) {
              keyboardTriggerBasic(e, closeOverlay);
            }
          }}
          tabIndex={0}
        />
      )}
      {/* ------------------------------------------------------- */}
    </div>
  );
}
export default OnboardingItemModule;
